import React, { Component, Fragment } from 'react';
import { withLocalize } from 'react-localize-redux';

class EdittableHeader extends Component {
  constructor(props) {
    super(props);

    this.textInput = React.createRef();
  }

  state = { isEditting: false };

  toggleEditting = () => {
    this.setState({ isEditting: !this.state.isEditting }, () => {
      // focus textarea after click
      if (this.state.isEditting) {
        this.textInput.current.focus();
      }
    });
  };

  render() {
    const { isEditting } = this.state;
    const { value, onChange, translate } = this.props;

    return (
      <Fragment>
        {isEditting ? (
          <input
            className='eventDetail_main_detail_heading-edit'
            ref={this.textInput}
            value={value}
            onChange={onChange}
            onBlur={this.toggleEditting}
          />
        ) : (
          <h3
            onClick={this.toggleEditting}
            className={`eventDetail_main_detail_heading${value ? '' : '-default'}`}
          >
            {value || translate('eventDetailTitle')}
          </h3>
        )}
      </Fragment>
    );
  }
}

export default withLocalize(EdittableHeader);



// WEBPACK FOOTER //
// ./src/components/contentEditor/components/edittableHeader.js